$(function () {
    "use strict";

    if (Modernizr.flexbox && !Modernizr.touch) {

        var $toStick = $('.tariff-packages__row_to-get-stick');

        if ($toStick.length > 0) {

            var basicOffsetTop = $toStick.offset().top;
            var basicOffsetLeft = $toStick.parent().offset().left;

            var onScroll = function () {

                if ($(window).scrollTop() >= basicOffsetTop) {
                    $toStick
                        .addClass('tariff-packages__row_sticked')
                        .css('left', basicOffsetLeft - $(window).scrollLeft());
                }
                else {
                    $toStick
                        .removeClass('tariff-packages__row_sticked')
                        .css('left', '');
                }

                basicOffsetLeft = $toStick.parent().offset().left;
            };

            $(window).on('scroll resize', onScroll);
        }
    }
});